import axios from "axios";

import APIHandler from "api/api-handler";

import { API_ROUTES } from "./const";

const fileUploadApi = {
  getUploadUrl: file => APIHandler.get({ url: API_ROUTES.generate_UPLOAD_FILE(file) }),
  s3FileUpload: (url, file) => axios.put(url, file, {
      headers: {
        "Content-Type": file.type
      }
    })
};

export default fileUploadApi;
